package com.essntl.features.itinerary.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.itinerary.data")
class ItineraryModule
